var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("a-spin", { attrs: { size: "large", spinning: _vm.loading } }, [
    _c("div", { staticClass: "main-box" }, [
      _c(
        "div",
        { staticClass: "header" },
        [
          _c(
            "span",
            { staticClass: "backer", on: { click: _vm.backHandler } },
            [
              _c("a-icon", { staticClass: "icon", attrs: { type: "left" } }),
              _vm._v(_vm._s(_vm.$t("stepBack"))),
            ],
            1
          ),
          _c(
            "a-button",
            {
              staticClass: "publish",
              attrs: { type: "primary" },
              on: { click: _vm.publish },
            },
            [_vm._v(_vm._s(_vm.$t("Publish")))]
          ),
          _c(
            "div",
            { staticClass: "title", class: [_vm.lang] },
            [
              _c("a-icon", {
                staticClass: "icon",
                style: { "margin-left": _vm.lang == "AR" ? "5px" : 0 },
                attrs: { type: "robot" },
              }),
              _vm._v(" " + _vm._s(_vm.$t("RealTimeDialogue")) + " "),
            ],
            1
          ),
          _c("div", { staticClass: "subtitle", class: [_vm.lang] }, [
            _vm._v(" " + _vm._s(_vm.$t("Conversedirectlywith")) + " "),
          ]),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialogWind",
          style: {
            maxHeight: _vm.maxWindowHeight + "px",
            minHeight: _vm.maxWindowHeight + "px",
          },
        },
        [
          _c(
            "simplebar",
            {
              ref: "scrollContainer",
              staticClass: "simplebarWrap-dialog",
              style: {
                maxHeight: _vm.maxWindowHeight + "px",
              },
              attrs: {
                "data-simplebar-auto-hide": "true",
                scrollbarMaxSize: 50,
              },
            },
            [
              _c("div", [
                _c("div", { staticClass: "talkWind" }, [
                  _c("div", { staticClass: "wrap-message" }, [
                    _c(
                      "ul",
                      [
                        _vm.initTips
                          ? _c("li", { staticClass: "leftTalk" }, [
                              _c("div", { staticClass: "box" }, [
                                _c("img", {
                                  attrs: {
                                    src: require("@/assets/img/robot.png"),
                                    alt: "",
                                  },
                                }),
                                _c("div", { staticClass: "wrap-info" }, [
                                  _c("div", { staticClass: "message" }, [
                                    _c("div", {
                                      staticClass: "messageText",
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.formatText(_vm.initTips)
                                        ),
                                      },
                                    }),
                                  ]),
                                ]),
                              ]),
                              _c("div", { staticStyle: { clear: "both" } }),
                            ])
                          : _vm._e(),
                        _vm._l(_vm.dialogList, function (item, index) {
                          return _c(
                            "li",
                            {
                              key: index,
                              class: {
                                rightTalk: item.role_type == 1 ? true : false,
                                leftTalk: item.role_type == 0 ? true : false,
                              },
                            },
                            [
                              item.type == "date"
                                ? _c("div", { staticClass: "date" }, [
                                    _vm._v(" " + _vm._s(item.date) + " "),
                                  ])
                                : _vm._e(),
                              item.role_type == 1
                                ? [
                                    _c("div", { staticClass: "box" }, [
                                      _c("div", { staticClass: "wrap-info" }, [
                                        _c("div", { staticClass: "message" }, [
                                          _c("div", {
                                            staticClass: "messageText",
                                            domProps: {
                                              innerHTML: _vm._s(item.content),
                                            },
                                          }),
                                          _c("div", { staticClass: "time" }, [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.formatTimeZoneTime(
                                                    item.create_date,
                                                    "HH:mm"
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]),
                                        ]),
                                      ]),
                                      _c("img", {
                                        attrs: {
                                          src: _vm.user.head_img,
                                          alt: _vm.user.user_name,
                                        },
                                        on: {
                                          error: function ($event) {
                                            return _vm.imgError($event)
                                          },
                                        },
                                      }),
                                    ]),
                                    _c("div", {
                                      staticStyle: { clear: "both" },
                                    }),
                                  ]
                                : _vm._e(),
                              item.role_type == 0 && item.parse_cate == "z"
                                ? [
                                    _c("div", { staticClass: "box" }, [
                                      _c("img", {
                                        attrs: {
                                          src: require("@/assets/img/robot.png"),
                                          alt: "",
                                        },
                                      }),
                                      _c(
                                        "div",
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "wrap-info" },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "message" },
                                                [
                                                  _c("div", {
                                                    domProps: {
                                                      innerHTML: _vm._s(
                                                        item.content
                                                      ),
                                                    },
                                                  }),
                                                  _c(
                                                    "div",
                                                    { staticClass: "time" },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.formatTimeZoneTime(
                                                              item.create_date,
                                                              "HH:mm"
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _vm._l(
                                            item.questionList,
                                            function (ditem, dindex) {
                                              return _c(
                                                "div",
                                                {
                                                  key: dindex,
                                                  staticClass: "question-ext",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.questionHandler(
                                                        ditem.question
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(ditem.question) +
                                                      " "
                                                  ),
                                                  _c("a-icon", {
                                                    staticClass: "icon",
                                                    attrs: { type: "right" },
                                                  }),
                                                ],
                                                1
                                              )
                                            }
                                          ),
                                        ],
                                        2
                                      ),
                                    ]),
                                    _c("div", {
                                      staticStyle: { clear: "both" },
                                    }),
                                  ]
                                : _vm._e(),
                              item.role_type == 0 && item.parse_cate != "z"
                                ? [
                                    _c("div", { staticClass: "box" }, [
                                      _c("img", {
                                        attrs: {
                                          src: require("@/assets/img/robot.png"),
                                          alt: "",
                                        },
                                      }),
                                      _c("div", { staticClass: "wrap-info" }, [
                                        _c("div", { staticClass: "message" }, [
                                          _c("div", [
                                            _c("div", {
                                              staticClass: "answerContent",
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  item.answer_content
                                                ),
                                              },
                                            }),
                                            _c("div", [
                                              _c(
                                                "span",
                                                {
                                                  on: {
                                                    click: function ($event) {
                                                      $event.stopPropagation()
                                                      return _vm.reviewHandler(
                                                        item
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v("review")]
                                              ),
                                              _vm._v(
                                                " " +
                                                  _vm._s(item.file_name) +
                                                  " "
                                              ),
                                            ]),
                                          ]),
                                          _c("div", { staticClass: "time" }, [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.formatTimeZoneTime(
                                                    item.create_date,
                                                    "HH:mm"
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]),
                                        ]),
                                      ]),
                                    ]),
                                    _c("div", {
                                      staticStyle: { clear: "both" },
                                    }),
                                  ]
                                : _vm._e(),
                            ],
                            2
                          )
                        }),
                        _vm.useWs && _vm.wsGetCont
                          ? _c("li", { staticClass: "leftTalk" }, [
                              _c("div", { staticClass: "box" }, [
                                _c("img", {
                                  attrs: {
                                    src: require("@/assets/img/robot.png"),
                                    alt: "",
                                  },
                                }),
                                _c("div", { staticClass: "wrap-info" }, [
                                  _c(
                                    "div",
                                    { staticClass: "message thinking" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "rotationtiao_left",
                                          staticStyle: {
                                            "margin-bottom": "10px",
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "gpt-flex-row" },
                                            [
                                              _c("a-icon", {
                                                staticClass: "rightIcon",
                                                attrs: { type: "check" },
                                              }),
                                              _c("div", [
                                                _vm._v(
                                                  _vm._s(_vm.$t("thinking"))
                                                ),
                                              ]),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "gpt-flex-row",
                                              staticStyle: {
                                                "margin-bottom": "10px",
                                              },
                                            },
                                            [
                                              _c("a-icon", {
                                                staticClass: "rightIcon",
                                                attrs: { type: "check" },
                                              }),
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "newLine",
                                                  staticStyle: {
                                                    width: "400px",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " Start Answering: " +
                                                      _vm._s(_vm.content_chat) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                          _c("div", {
                                            staticClass: "messageContent",
                                            attrs: { id: "messageContent" },
                                          }),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]),
                              ]),
                            ])
                          : _vm._e(),
                        _vm.sending
                          ? _c("li", { staticClass: "leftTalk" }, [
                              _c("div", { staticClass: "box" }, [
                                _c("img", {
                                  attrs: {
                                    src: require("@/assets/img/robot.png"),
                                    alt: "",
                                  },
                                }),
                                _c("div", { staticClass: "wrap-info" }, [
                                  _c(
                                    "div",
                                    { staticClass: "message thinking" },
                                    [
                                      _c("div", { staticClass: "text" }, [
                                        _vm._v("thinking"),
                                      ]),
                                      _c(
                                        "div",
                                        { staticClass: "loading-chat" },
                                        [_c("div"), _c("div"), _c("div")]
                                      ),
                                    ]
                                  ),
                                ]),
                              ]),
                              _c("div", { staticStyle: { clear: "both" } }),
                            ])
                          : _vm._e(),
                      ],
                      2
                    ),
                  ]),
                ]),
              ]),
            ]
          ),
        ],
        1
      ),
      _c(
        "div",
        { ref: "messageBox", staticClass: "messageBox" },
        [
          _c("svg-icon", {
            staticClass: "icon",
            attrs: { iconClass: "message" },
          }),
          _c(
            "div",
            { staticClass: "text", class: { noclick: _vm.noclick } },
            [
              _c("a-input", {
                staticClass: "textCont",
                staticStyle: { "overflow-y": "auto" },
                attrs: {
                  placeholder: _vm.$t("Pleaseenteryourreply"),
                  autoSize: { minRows: 2, maxRows: 10 },
                  type: "textarea",
                },
                on: { input: _vm.changeHandler },
                model: {
                  value: _vm.messageInfo,
                  callback: function ($$v) {
                    _vm.messageInfo = $$v
                  },
                  expression: "messageInfo",
                },
              }),
            ],
            1
          ),
          _c("a-icon", {
            staticStyle: { "margin-left": "10px", cursor: "pointer" },
            attrs: { type: "close-circle" },
            on: { click: _vm.clearHandler },
          }),
          _c(
            "span",
            { on: { click: _vm.sendHandler } },
            [
              !_vm.sending && !_vm.btn_loading
                ? _c("svg-icon", {
                    staticClass: "send",
                    attrs: { iconClass: "send" },
                  })
                : _vm._e(),
            ],
            1
          ),
          _c(
            "span",
            { on: { click: _vm.redoHandler } },
            [
              !_vm.sending && !_vm.btn_loading && _vm.dialogList.length > 1
                ? _c("a-icon", {
                    staticClass: "redo",
                    attrs: { type: "reload" },
                  })
                : _vm._e(),
            ],
            1
          ),
          _vm.sending || _vm.btn_loading
            ? _c(
                "div",
                {
                  staticClass: "sending",
                  style: { cursor: _vm.btn_loading ? "pointer" : "default" },
                  on: { click: _vm.stopAnswer },
                },
                [_c("div", { staticClass: "circle" })]
              )
            : _vm._e(),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }